import { ProductTagBase } from '../ProductTagBase';
import klass from '../style/ProductTag.module.scss';

/**
 * @figma
 * https://www.figma.com/design/Top00pi5q5ylSxEviOOciV/MarppleShop-Design-System?node-id=21842-60147&m=dev
 */
export class SoldOutTag extends ProductTagBase<undefined> {
  protected makeLabel(): string {
    return ET('mps2::product::tag::sold_out', { lng: this.data.lang });
  }

  protected styles(): string {
    return klass.sold_out;
  }

  isTimerNeeded(): boolean {
    return false;
  }
}
